import { FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    ID_UPLOAD_RESET_VALUE,
    ID_UPLOAD_SET_VALUE,
    ID_UPLOAD_SET_VALID,
    LICENSE_UPLOAD_RESET_VALUE,
    LICENSE_UPLOAD_SET_VALUE,
    LICENSE_UPLOAD_SET_VALID,
    LOG_BOOK_UPLOAD_RESET_VALUE,
    LOG_BOOK_UPLOAD_SET_VALID,
    LOG_BOOK_UPLOAD_SET_VALUE,
    VALUATION_REPORT_RESET_VALUE,
    VALUATION_REPORT_SET_VALID,
    VALUATION_REPORT_SET_VALUE,
    INSPECTION_PHOTO_SET_VALUE,
    INSPECTION_PHOTO_SET_VALID,
    INSPECTION_PHOTO_RESET_VALUE,
    EXTRA_PHOTOS_SET_VALUE,
    EXTRA_PHOTOS_SET_VALID,
    EXTRA_PHOTOS_RESET_VALUE,
    FORM_VALID_MOTOR_INSURANCE_DOCUMENTS_FORM,
    FORM_INVALID_MOTOR_INSURANCE_DOCUMENTS_FORM,
    DOCUMENT_TYPE_SET_VALUE,
    DOCUMENT_TYPE_SET_VALID,
    CAR_FRONT_PHOTO_SET_VALUE,
    CAR_FRONT_PHOTO_SET_VALID,
    CAR_FRONT_PHOTO_RESET_VALUE,
    CAR_BACK_PHOTO_SET_VALUE,
    CAR_BACK_PHOTO_RESET_VALUE,
    CAR_BACK_PHOTO_SET_VALID,
    CHASSIS_NUMBER_PHOTO_SET_VALID,
    CHASSIS_NUMBER_PHOTO_SET_VALUE,
    CHASSIS_NUMBER_PHOTO_RESET_VALUE,
    INTERIOR_DASHBOARD_PHOTO_SET_VALUE,
    INTERIOR_DASHBOARD_PHOTO_RESET_VALUE,
    INTERIOR_DASHBOARD_PHOTO_SET_VALID,
    INTERIOR_RADIO_PHOTO_RESET_VALUE,
    INTERIOR_RADIO_PHOTO_SET_VALID,
    ENGINE_PHOTO_SET_VALUE,
    ENGINE_PHOTO_RESET_VALUE,
    ENGINE_PHOTO_SET_VALID,
    INTERIOR_RADIO_PHOTO_SET_VALUE,
    SALES_AGREEMENT_SET_VALUE,
    SALES_AGREEMENT_RESET_VALUE,
    SALES_AGREEMENT_SET_VALID,
    CAR_RIGHT_PHOTO_SET_VALUE,
    CAR_RIGHT_PHOTO_RESET_VALUE,
    CAR_RIGHT_PHOTO_SET_VALID,
    CAR_LEFT_PHOTO_SET_VALUE,
    CAR_LEFT_PHOTO_RESET_VALUE,
    CAR_LEFT_PHOTO_SET_VALID,
    DOCUMENT_DETAILS_SUBMITTED_SET_VALUE,
} from '../../actions/ugMotorInsurance/Documents';

export const initDocuments = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    documentDetailsSubmitted: false,
    form: {
        idUpload: { value: null, error: null, status: null },
        licenseUpload: { value: null, error: null, status: null },
        logbookUpload: { value: null, error: null, status: null },
        valuationReportUpload: { value: null, error: null, status: null },
        inspectionPhoto: { value: null, error: null, status: null },
        extraPhotos: { value: null, error: null, status: null },
        //additional ug
        documentType: { value: null, error: null, status: null },
        carFrontViewPhoto: { value: null, error: null, status: null },
        carBackViewPhoto: { value: null, error: null, status: null },
        carLeftViewPhoto: { value: null, error: null, status: null },
        carRightViewPhoto: { value: null, error: null, status: null },
        chassisNumberPhoto: { value: null, error: null, status: null },
        carDashboardPhoto: { value: null, error: null, status: null },
        interiorRadioPhoto: { value: null, error: null, status: null },
        enginePhoto: { value: null, error: null, status: null },
        salesAgreement: { value: null, error: null, status: null },
    },
};

export default (state = initDocuments, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_MOTOR_INSURANCE_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_MOTOR_INSURANCE_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case DOCUMENT_DETAILS_SUBMITTED_SET_VALUE:
            return {
                ...state,
                documentDetailsSubmitted: action.value,
            };

        // ID UPLOAD

        case ID_UPLOAD_SET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_UPLOAD_SET_VALID:
            return updateFormField('idUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_UPLOAD_RESET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: null,
            }));

        // LICENSE UPLOAD
        case LICENSE_UPLOAD_SET_VALUE:
            return updateFormField('licenseUpload', (field) => ({ ...field, value: action.value }));

        case LICENSE_UPLOAD_RESET_VALUE:
            return updateFormField('licenseUpload', (field) => ({
                ...field,
                value: null,
            }));

        case LICENSE_UPLOAD_SET_VALID:
            return updateFormField('licenseUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        // LOGBOOK UPLOAD
        case LOG_BOOK_UPLOAD_SET_VALUE:
            return updateFormField('logbookUpload', (field) => ({ ...field, value: action.value }));

        case LOG_BOOK_UPLOAD_RESET_VALUE:
            return updateFormField('logbookUpload', (field) => ({
                ...field,
                value: null,
            }));

        case LOG_BOOK_UPLOAD_SET_VALID:
            return updateFormField('logbookUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        // Valuation Report upload
        case VALUATION_REPORT_SET_VALUE:
            return updateFormField('valuationReportUpload', (field) => ({ ...field, value: action.value }));

        case VALUATION_REPORT_RESET_VALUE:
            return updateFormField('valuationReportUpload', (field) => ({
                ...field,
                value: null,
            }));

        case VALUATION_REPORT_SET_VALID:
            return updateFormField('valuationReportUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        // Inspection Photo Upload
        case INSPECTION_PHOTO_SET_VALUE:
            return updateFormField('inspectionPhoto', (field) => ({ ...field, value: action.value }));

        case INSPECTION_PHOTO_RESET_VALUE:
            return updateFormField('inspectionPhoto', (field) => ({
                ...field,
                value: null,
            }));

        case INSPECTION_PHOTO_SET_VALID:
            return updateFormField('inspectionPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EXTRA_PHOTOS_SET_VALUE:
            return updateFormField('extraPhotos', (field) => ({ ...field, value: action.value }));

        case EXTRA_PHOTOS_SET_VALID:
            return updateFormField('extraPhotos', (field) => ({
                ...field,
                value: null,
            }));

        case EXTRA_PHOTOS_RESET_VALUE:
            return updateFormField('extraPhotos', (field) => ({
                ...field,
                value: null,
            }));

        //new ug extra
        case CAR_FRONT_PHOTO_SET_VALUE:
            return updateFormField('carFrontViewPhoto', (field) => ({ ...field, value: action.value }));
        case CAR_FRONT_PHOTO_RESET_VALUE:
            return updateFormField('carFrontViewPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case CAR_FRONT_PHOTO_SET_VALID:
            return updateFormField('carFrontViewPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CAR_BACK_PHOTO_SET_VALUE:
            return updateFormField('carBackViewPhoto', (field) => ({ ...field, value: action.value }));
        case CAR_BACK_PHOTO_RESET_VALUE:
            return updateFormField('carBackViewPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case CAR_BACK_PHOTO_SET_VALID:
            return updateFormField('carBackViewPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CAR_RIGHT_PHOTO_SET_VALUE:
            return updateFormField('carRightViewPhoto', (field) => ({ ...field, value: action.value }));
        case CAR_RIGHT_PHOTO_RESET_VALUE:
            return updateFormField('carRightViewPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case CAR_RIGHT_PHOTO_SET_VALID:
            return updateFormField('carRightViewPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CAR_LEFT_PHOTO_SET_VALUE:
            return updateFormField('carLeftViewPhoto', (field) => ({ ...field, value: action.value }));
        case CAR_LEFT_PHOTO_RESET_VALUE:
            return updateFormField('carLeftViewPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case CAR_LEFT_PHOTO_SET_VALID:
            return updateFormField('carLeftViewPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CHASSIS_NUMBER_PHOTO_SET_VALUE:
            return updateFormField('chassisNumberPhoto', (field) => ({ ...field, value: action.value }));
        case CHASSIS_NUMBER_PHOTO_RESET_VALUE:
            return updateFormField('chassisNumberPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case CHASSIS_NUMBER_PHOTO_SET_VALID:
            return updateFormField('chassisNumberPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case INTERIOR_DASHBOARD_PHOTO_SET_VALUE:
            return updateFormField('carDashboardPhoto', (field) => ({ ...field, value: action.value }));
        case INTERIOR_DASHBOARD_PHOTO_RESET_VALUE:
            return updateFormField('carDashboardPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case INTERIOR_DASHBOARD_PHOTO_SET_VALID:
            return updateFormField('carDashboardPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case INTERIOR_RADIO_PHOTO_SET_VALUE:
            return updateFormField('interiorRadioPhoto', (field) => ({ ...field, value: action.value }));
        case INTERIOR_RADIO_PHOTO_RESET_VALUE:
            return updateFormField('interiorRadioPhoto', (field) => ({
                ...field,
                value: null,
            }));
        case INTERIOR_RADIO_PHOTO_SET_VALID:
            return updateFormField('interiorRadioPhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ENGINE_PHOTO_SET_VALUE:
            return updateFormField('enginePhoto', (field) => ({ ...field, value: action.value }));
        case ENGINE_PHOTO_RESET_VALUE:
            return updateFormField('enginePhoto', (field) => ({
                ...field,
                value: null,
            }));
        case ENGINE_PHOTO_SET_VALID:
            return updateFormField('enginePhoto', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SALES_AGREEMENT_SET_VALUE:
            return updateFormField('salesAgreement', (field) => ({ ...field, value: action.value }));
        case SALES_AGREEMENT_RESET_VALUE:
            return updateFormField('salesAgreement', (field) => ({
                ...field,
                value: null,
            }));
        case SALES_AGREEMENT_SET_VALID:
            return updateFormField('salesAgreement', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DOCUMENT_TYPE_SET_VALUE:
            return updateFormField('documentType', (field) => ({ ...field, value: action.value }));

        case DOCUMENT_TYPE_SET_VALID:
            return updateFormField('documentType', (field) => ({
                ...field,
                value: null,
            }));

        // Reset the state
        case REINITIALIZE:
            return initDocuments;
        default:
            return state;
    }
};
